// Common initialization
var xVal = xVal || {};
xVal.Plugins = xVal.Plugins || {};
xVal.Messages = xVal.Messages || {};
xVal.AttachValidator = function (elementPrefix, rulesConfig, pluginName, options, formName) {

	if (pluginName != null && this.Plugins[pluginName] != undefined)
		this.Plugins[pluginName].AttachValidator(elementPrefix, rulesConfig, options,formName);
	else
		for (var key in this.Plugins) {

		    this.Plugins[key].AttachValidator(elementPrefix, rulesConfig, options, formName);
		return;
	}
};

// xVal.jquery.validate.js
// An xVal plugin to enable support for jQuery Validate
// http://xval.codeplex.com/
// (c) 2009 Steven Sanderson
// License: Microsoft Public License (Ms-PL) (http://www.opensource.org/licenses/ms-pl.html)

(function($) {
	var xValLogger = console.getLogger("xValLogger");

	xVal.Plugins["jquery.validate"] = {
		AttachValidator: function(elementPrefix, rulesConfig, options, formName) {
			if (!options)
			    options = {};
		    
			xValLogger.group("AttachValidator: ", this);
			xValLogger.info("Arguments: ", arguments);
			this._ensureCustomFunctionsRegistered();
			for (var i = 0; i < rulesConfig.Fields.length; i++) {

				var fieldName = rulesConfig.Fields[i].FieldName;
				var fieldRules = rulesConfig.Fields[i].FieldRules;

				try {
					// Is there a matching DOM element?
				    var elemId = (elementPrefix ? elementPrefix + "." : "") + fieldName;
				    var frm = formName != undefined && formName != null && formName != "" ? $("#" + formName) : [];
				    var elem = $('*[name="' + elemId + '"]');
				    if (frm.length > 0)
				        elem = $('*[name="' + elemId + '"]',frm);
					if (elem.length > 0) {
						xValLogger.group("Attaching rules to ", elem[0]);
						for (var j = 0; j < fieldRules.length; j++) {

							var ruleName = fieldRules[j].RuleName;
							var ruleParams = fieldRules[j].RuleParameters;
							var errorText = (typeof (fieldRules[j].Message) == 'undefined' ? null : fieldRules[j].Message);
							this._attachRuleToDOMElement(ruleName, ruleParams, errorText, elem, elementPrefix, options, formName);
						}
						xValLogger.groupEnd();
					}
				}
				catch (err) {
					alert("Could not attach rules to " + fieldName + ". Error message: " + err);
				}
			}
		},
		_attachRuleToDOMElement: function (ruleName, ruleParams, errorText, element, elementPrefix, validationoptions, formName) {

		    var parentForm = element.parents("form");
		    
			if (parentForm.length != 1) {
			    
		        alert("Error: Element " + element.attr("id") + " is not in a form");
		    }


		    this._ensureFormIsMarkedForValidation($(parentForm[0]), validationoptions);
			this._associateNearbyValidationMessageSpanWithElement(element);

			var options = {};
			var getMinMaxValue = function(params) {
			  
				if (params.Type == "datetime")
					return new Date(params.ValueYear, params.ValueMonth - 1, params.ValueDay, params.ValueHour, params.ValueMinute, params.ValueSecond);
				return params.Value;
			};
			switch (ruleName) {
				case "Required":
					options.required = true;
					options.messages = { required: errorText || xVal.Messages.Required };
					xValLogger.debug("Attaching required rule", options, element);
					break;
				case "Min":


					options.xVal_minError = { value: getMinMaxValue(ruleParams), type: ruleParams.Type };
					options.messages = { xVal_minError: errorText };
					break;
				case "Max":

					options.xVal_maxError = { value: getMinMaxValue(ruleParams), type: ruleParams.Type };
					options.messages = { xVal_maxError: errorText };
					break;
				case "MinWarning":

					options.xVal__minWarning = { value: getMinMaxValue(ruleParams), type: ruleParams.Type };
					options.messages = { xVal__minWarning: errorText };
					break;
				case "MaxWarning":

					options.xVal__maxWarning = { value: getMinMaxValue(ruleParams), type: ruleParams.Type };
					options.messages = { xVal__maxWarning: errorText };
					break;
				case "Range":
					if (ruleParams.Type == "string") {
						options.xVal_stringRange = [ruleParams.Min, ruleParams.Max];
						if (errorText != null) options.messages = { xVal_stringRange: $.format(errorText) };
					}
					else if (ruleParams.Type == "datetime") {
						var minDate, maxDate;
						if (typeof (ruleParams.MinYear) != 'undefined')
							minDate = new Date(ruleParams.MinYear, ruleParams.MinMonth - 1, ruleParams.MinDay, ruleParams.MinHour, ruleParams.MinMinute, ruleParams.MinSecond);
						if (typeof (ruleParams.MaxYear) != 'undefined')
							maxDate = new Date(ruleParams.MaxYear, ruleParams.MaxMonth - 1, ruleParams.MaxDay, ruleParams.MaxHour, ruleParams.MaxMinute, ruleParams.MaxSecond);
						options.xVal_dateRange = [minDate, maxDate];
						if (errorText != null) options.messages = { xVal_dateRange: $.format(errorText) };
					}
					else if (typeof (ruleParams.Min) == 'undefined') {
						options.max = ruleParams.Max;
						errorText = errorText || xVal.Messages.Range_Numeric_Max;
						if (errorText != null) options.messages = { max: $.format(errorText) };
					}
					else if (typeof (ruleParams.Max) == 'undefined') {
						options.min = ruleParams.Min;
						errorText = errorText || xVal.Messages.Range_Numeric_Min;
						if (errorText != null) options.messages = { min: $.format(errorText) };
					}
					else {
						options.range = [ruleParams.Min, ruleParams.Max];
						errorText = errorText || xVal.Messages.Range_Numeric_MinMax;
						if (errorText != null) options.messages = { range: $.format(errorText) };
					}

					break;

				case "StringLength":
					if (typeof (ruleParams.MinLength) == 'undefined') {
						options.maxlength = ruleParams.MaxLength;
						errorText = errorText || xVal.Messages.StringLength_Max;
						if (errorText != null) options.messages = { maxlength: $.format(errorText) };
					}
					else if (typeof (ruleParams.MaxLength) == 'undefined') {
						options.minlength = ruleParams.MinLength;
						errorText = errorText || xVal.Messages.StringLength_Min;
						if (errorText != null) options.messages = { minlength: $.format(errorText) };
					}
					else {
						options.rangelength = [ruleParams.MinLength, ruleParams.MaxLength];
						errorText = errorText || xVal.Messages.StringLength_MinMax;
						if (errorText != null) options.messages = { rangelength: $.format(errorText) };
					}
					break;

				case "DataType":
					switch (ruleParams.Type) {
						case "EmailAddress":
							options.email = true;
							options.messages = { email: errorText || xVal.Messages.DataType_EmailAddress };
							break;
						case "Integer":
							options.xVal_regex = ["^\\-?\\d+$", ""];
							options.messages = { xVal_regex: errorText || xVal.Messages.DataType_Integer || "Please enter a whole number." };
							break;
						case "Decimal":
							options.number = true;
							options.messages = { number: errorText || xVal.Messages.DataType_Decimal };
							break;
						case "Date":
							options.date = true;
							options.messages = { date: errorText || xVal.Messages.DataType_Date };
							break;
						case "DateTime":
							options.date = true; //xVal_regex = ["^\\d{1,2}/\\d{1,2}/(\\d{2}|\\d{4})\\s+\\d{1,2}\\:\\d{2}(\\:\\d{2})?$", ""];
							options.messages = { xVal_regex: errorText || xVal.Messages.DataType_DateTime || "Please enter a valid date and time." };
							break;
						case "Currency":
							options.xVal_regex = ["^\\D?\\s?([0-9]{1,3},([0-9]{3},)*[0-9]{3}|[0-9]+)(.[0-9][0-9])?$", ""];
							options.messages = { xVal_regex: errorText || xVal.Messages.DataType_Currency || "Please enter a currency value." };
							break;
						case "CreditCardLuhn":
							options.xVal_creditCardLuhn = true;
							if (errorText != null) options.messages = { xVal_creditCardLuhn: errorText };
							break;
					}
					break;

				case "RegEx":
					options.xVal_regex = [ruleParams.Pattern, ruleParams.Options];
					if (errorText != null) options.messages = { xVal_regex: errorText };
					xValLogger.debug("Attaching RegEx rule", options, element);
					break;

				case "Comparison":
					var elemToCompareId = this._makeAspNetMvcHtmlHelperID((elementPrefix ? elementPrefix + "." : "") + ruleParams.PropertyToCompare);
					var elemToCompare = document.getElementById(elemToCompareId);
					if (elemToCompare != null) {
						options.xVal_comparison = [ruleParams.PropertyToCompare, elemToCompare, ruleParams.ComparisonOperator];
						if (errorText != null) options.messages = { xVal_comparison: errorText };
					}
					break;

				case "Custom":
					var ruleFunction = this._parseAsFunctionWithWarnings(ruleParams.Function);
					if (ruleFunction != null) {
						var customFunctionName = this._registerCustomValidationFunction(ruleFunction);
						var evaluatedParams = ruleParams.Parameters == "null" ? null : eval("(" + ruleParams.Parameters + ")");
						options[customFunctionName] = evaluatedParams || true;
						options.messages = [];
						options.messages[customFunctionName] = errorText;
					}
					break;
			}

			element.rules("add", options);
			xValLogger.debug("Attached rule", options, element);

		},

		_parseAsFunctionWithWarnings: function(functionString) {
			var result;
			try { result = eval("(" + functionString + ")") }
			catch (ex) {
				alert("Custom rule error: Could not find or could not parse the function '" + functionString + "'");
				return null;
			}
			if (typeof (result) != 'function') {
				alert("Custom rule error: The JavaScript object '" + functionString + "' is not a function.");
				return null;
			}
			return result;
		},

		_associateNearbyValidationMessageSpanWithElement: function(element) {
			// If there's a <span class='field-validation-error'> soon after, it's probably supposed to display the error message
			// jquery.validation goes looking for attributes called "htmlfor" and "generated", set as follows
			var nearbyMessages = element.nextAll("span.field-validation-error");
			if (nearbyMessages.length > 0) {
				$(nearbyMessages[0]).attr("generated", "true")
																		.attr("htmlfor", element.attr("id"));
			}
		},

		_ensureFormIsMarkedForValidation: function(formElement, options) {
			if (!formElement.data("isMarkedForValidation")) {

				var settings = {
					errorClass: "field-validation-error",
					errorElement: "span",
					highlight: function(element) { $(element).addClass("input-validation-error"); },
					unhighlight: function(element) { $(element).removeClass("input-validation-error"); }
				};
				$.extend(settings, options);

				formElement.data("isMarkedForValidation", true);
				formElement.validate(settings);
			}
		},

		_registerCustomValidationFunction: function(evalFn) {
			jQuery.validator.xValCustomFunctionCount = (jQuery.validator.xValCustomFunctionCount || 0) + 1;
			var functionName = "xVal_customFunction_" + jQuery.validator.xValCustomFunctionCount;
			jQuery.validator.addMethod(functionName, function(value, element, params) {
				if (this.optional(element))
					return true;
				return evalFn(value, element, params);
			});
			return functionName;
		},

		_ensureCustomFunctionsRegistered: function() {
			if (!jQuery.validator.xValFunctionsRegistered) {
				jQuery.validator.xValFunctionsRegistered = true;
				// Min Error:


				// Min Warning:
				jQuery.validator.addMethod("xVal__minWarning", function(value, element, params) {
				
					if (this.optional(element)) return true;
					if (params != null) {
						var parsedValue = value;
						var compareValue = params.value;
						if (params.type == "datetime") {
						    // MZ: Can't rely on getDate, it doesn't always refresh immediately
						    try { 
						        parsedValue = $.datepicker.parseDate($(element).datepicker('option', 'dateFormat'), value);
						    } catch (e) {
						        parsedValue = $(element).datepicker('getDate');
						    }
						    if (parsedValue == undefined || parsedValue == null || isNaN(parsedValue)) {
						        parsedValue = $(element).getDateValue();
						    }

						}
						if (params.type == "integer") {
							parsedValue = parseInt(parsedValue);
							compareValue = parseInt(compareValue);
						}
						if (params.type == "decimal") {
							parsedValue = parseFloat(parsedValue);
							compareValue = parseFloat(compareValue);
						}
						if (params.value != null) {
							if (parsedValue < compareValue) {
								// Display warning message, but pass validation
								// Only display message once per value-change
								if (element.previousValue == undefined || element.previousValue != parsedValue.toString()) {
									$(element).data('warningMessage', this.defaultMessage(element, "xVal__minWarning"));
									$(element).data('failedMinWarning','true');
								    // Only show the message on the element Blur event
								    var showWarning = function() { if ($(element).data('failedMinWarning') != undefined && $(element).data('failedMinWarning') != 'false') $(this).trigger('showValidationWarning', $(element).data('warningMessage')); };
								    if (!$(element).is('.hasDatepicker') || $(element).datepicker("widget").is(":visible"))
								        $(element).one('blur', showWarning);
								    else
								        showWarning.apply(element);
								} 
								element.previousValue = parsedValue.toString();

								return true;
							} else {
								// Within range, so clear flag
								$(element).data('failedMinWarning','false');
							}
						}
					}
					return true;

				}, function(params, elem) {
				    var formatDate = function (date) {
				        return $(elem).formatDate(dateValue);
					};
					var value = params.value;
					if (params.type == 'date')
						value = formatDate(params.value);
					return $.format(xVal.Messages.minError || "Please enter a value no less than {0}.", value);
				});
				xValLogger.debug("Added custom validation xVal__minWarning");
				// Max Warning:
				jQuery.validator.addMethod("xVal__maxWarning", function(value, element, params) {
					if (this.optional(element)) return true;
					if (params != null) {
						var parsedValue = value;
						var compareValue = params.value;
						if (params.type == "datetime") {
						    try {
						        parsedValue = $.datepicker.parseDate($(element).datepicker('option', 'dateFormat'), value);
						    } catch(e) {
						        parsedValue = $(element).datepicker('getDate');
						    }
						    if (parsedValue == undefined || parsedValue == null || isNaN(parsedValue)) {
						        parsedValue = $(element).getDateValue();
						    }
						}
						if (params.type == "integer") {
							parsedValue = parseInt(parsedValue);
							compareValue = parseInt(compareValue);
						}
						if (params.type == "decimal") {
							parsedValue = parseFloat(parsedValue);
							compareValue = parseFloat(compareValue);
						}
						if (parsedValue > compareValue) {
							// Display warning message, but pass validation
						    // Only display message once per value-change
						    if (this.previousValue == undefined && $(element).data('previousValue'))
						        this.previousValue = $(element).data('previousValue');
							if (this.previousValue == undefined || this.previousValue != parsedValue.toString()) {
								$(element).data('warningMessage', this.defaultMessage(element, "xVal__maxWarning"));
								$(element).data('failedMaxWarning','true');
							    // Show message on blur event
							    
								var showWarning = function () { if ($(element).data('failedMaxWarning') != undefined && $(element).data('failedMaxWarning') != 'false') $(this).trigger('showValidationWarning', $(element).data('warningMessage')); };
								if (!$(element).is('.hasDatepicker') || $(element).datepicker("widget").is(":visible"))
								    $(element).one('blur', showWarning);
								else
								    showWarning.apply(element);
								
							}
							this.previousValue = parsedValue.toString();
							return true;
						} else {
								// Within range, so clear flag
								$(element).data('failedMaxWarning','false');
						}
					}
					return true;
				}, function(params, elem) {
				    var formatDate = function (date) {
				        return $(elem).formatDateValue(date);
				    };

					var value = params.value;
					if (params.type == 'date')
						value = formatDate(params.value);
					return $.format(xVal.Messages.minError || "Please enter a value no greater than {0}.", value);
				});
				xValLogger.debug("Added custom validation xVal__maxWarning");
				jQuery.validator.addMethod("xVal_minError", function(value, element, params) {

					if (this.optional(element)) return true;
					if (params != null) {
						var parsedValue = value;
						var compareValue = params.value;
						if (params.type == "datetime") {
						    try{
						        parsedValue = $.datepicker.parseDate($(element).datepicker('option', 'dateFormat'), value);
						    } catch (e) {
						        parsedValue = $(element).datepicker('getDate');
						    }
						    if (parsedValue == undefined || parsedValue == null || isNaN(parsedValue)) {
						        parsedValue = $(element).getDateValue();
						    }
						}
						if (params.type == "integer") {
							parsedValue = parseInt(parsedValue);
							compareValue = parseInt(compareValue);
						}
						if (params.type == "decimal") {
							parsedValue = parseFloat(parsedValue);
							compareValue = parseFloat(compareValue);
						}
						this.previousValue = parsedValue.toString();
						if (params.value != null)
							if (parsedValue < compareValue) return false;
					}
					return true;
				}, function(params, elem) {
				    var formatDate = function (date) {
				        return $(elem).is('.flatpickr-input').formatDateValue(date);
					};

					var value = params.value;
					if (params.type == 'datetime')
						value = formatDate(params.value);
					return $.format(xVal.Messages.minError || "Please enter a value no less than {0}.", value);

				});
				xValLogger.debug("Added custom validation xVal_minError");
				// Max Error:
				jQuery.validator.addMethod("xVal_maxError", function(value, element, params) {

					if (this.optional(element)) return true;
					if (params != null) {
						var parsedValue = value;
						var compareValue = params.value;
						if (params.type == "datetime") {
						    try {
						        parsedValue = $.datepicker.parseDate($(element).datepicker('option', 'dateFormat'), value);
						    } catch (e) {
						        parsedValue = $(element).datepicker('getDate');
						    }
						    if (parsedValue == undefined || parsedValue == null || isNaN(parsedValue)) {
						        parsedValue = $(element).getDateValue();

						    }
						        
						}
						if (params.type == "integer") {
							parsedValue = parseInt(parsedValue);
							compareValue = parseInt(compareValue);
						}
						if (params.type == "decimal") {
							parsedValue = parseFloat(parsedValue);
							compareValue = parseFloat(compareValue);
						}
						this.previousValue = parsedValue.toString();
						if (params.value != null)
							if (parsedValue > compareValue) return false;
					}
					return true;
				}, function(params, elem) {
				    var formatDate = function (date) {
				        
				            return $(elem).formatDateValue(date);
				        };

					var value = params.value;
					if (params.type == 'datetime')
						value = formatDate(params.value);
					return $.format(xVal.Messages.minError || "Please enter a value no greater than {0}.", value);
				});
				xValLogger.debug("Added custom validation xVal_maxError");
				jQuery.validator.addMethod("xVal_stringRange", function(value, element, params) {
					if (this.optional(element)) return true;
					if (params[0] != null)
						if (value < params[0]) return false;
					if (params[1] != null)
						if (value > params[1]) return false;
					return true;
				}, function(params) {
					if ((params[0] != null) && (params[1] != null))
						return $.format(xVal.Messages.Range_String_MinMax || "Please enter a value alphabetically between '{0}' and '{1}'.", params[0], params[1]);
					else if (params[0] != null)
						return $.format(xVal.Messages.Range_String_Min || "Please enter a value not alphabetically before '{0}'.", params[0]);
					else
						return $.format(xVal.Messages.Range_String_Max || "Please enter a value not alphabetically after '{0}'.", params[1]);
				});
				xValLogger.debug("Added custom validation xVal_stringRange");
				jQuery.validator.addMethod("xVal_dateRange", function(value, element, params) {

					if (this.optional(element)) return true;
				    var parsedValue = null;
				    try { 
				         parsedValue = $.datepicker.parseDate($(element).datepicker('option', 'dateFormat'), value);
				    } catch (e) {
				        parsedValue = $(element).datepicker('getDate');
				    }
				    if (parsedValue == undefined || parsedValue == null || isNaN(parsedValue)) {
				        parsedValue = $(element).getDateValue();
				        
				    }
				    if (params[0] != null)
						if (parsedValue < params[0]) return false;
					if (params[1] != null)
						if (parsedValue > params[1]) return false;

					return true;
				}, function(params, elem) {
				    var formatDate = function (date) {
				        $(elem).formatDateValue(date);
					};
					if ((params[0] != null) && (params[1] != null))
						return $.format(xVal.Messages.Range_DateTime_MinMax || "Please enter a date between {0} and {1}.", formatDate(params[0]), formatDate(params[1]));
					else if (params[0] != null)
						return $.format(xVal.Messages.Range_DateTime_Min || "Please enter a date no earlier than {0}.", formatDate(params[0]));
					else
						return $.format(xVal.Messages.Range_DateTime_Max || "Please enter a date no later than {0}.", formatDate(params[1]));
				});
				xValLogger.debug("Added custom validation xVal_dateRange");
				jQuery.validator.addMethod("xVal_regex", function(value, element, params) {
					console.debug("Applying regex rule", value, element, params, arguments.callee.caller);
					if (this.optional(element)) return true;
					var pattern = params[0];
					var options = params[1];
					var regex = new RegExp(pattern, options);
					return regex.test(value);
				}, function(params) {
					return xVal.Messages.Regex || "This value is invalid."; // Pity we can't be more descriptive
				});
				xValLogger.debug("Added custom validation xVal_regex");
				jQuery.validator.addMethod("xVal_creditCardLuhn", function(value, element, params) {
					if (this.optional(element)) return true;
					value = value.replace(/\D/g, "");
					if (value == "") return false;
					var sum = 0;
					for (var i = value.length - 2; i >= 0; i -= 2)
						sum += Array(0, 2, 4, 6, 8, 1, 3, 5, 7, 9)[parseInt(value.charAt(i), 10)];
					for (var i = value.length - 1; i >= 0; i -= 2)
						sum += parseInt(value.charAt(i), 10);
					return (sum % 10) == 0;
				}, function(params) {
					return xVal.Messages.DataType_CreditCardLuhn || "Please enter a valid credit card number.";
				});
				xValLogger.debug("Added custom validation xVal_creditCardLuhn");
				jQuery.validator.addMethod("xVal_comparison", function(value, element, params) {
					if (this.optional(element)) return true;
					var elemToCompare = params[1];
					var comparisonOperator = params[2];
					switch (comparisonOperator) {
						case "Equals": return value == elemToCompare.value;
						case "DoesNotEqual": return value != elemToCompare.value;
					}
					return true; // Ignore unrecognized operator
				}, function(params) {
					var propertyToCompareName = params[0];
					var comparisonOperator = params[2];
					switch (comparisonOperator) {
						case "Equals": return $.format(xVal.Messages.Comparison_Equals || "This value must be the same as {0}.", propertyToCompareName);
						case "DoesNotEqual": return $.format(xVal.Messages.Comparison_DoesNotEqual || "This value must be different from {0}.", propertyToCompareName);
					}
				});
				xValLogger.debug("Added custom validation xVal_comparison");
				xValLogger.debug("Added custom validation methods");
			}
			xValLogger.groupEnd();
		}

	};
	$.validator.addMethod('date', function(value, element) {
	    var dateValue = null;
	    
	    try { 
	        dateValue = $.datepicker.parseDate($(element).datepicker('option', 'dateFormat'), value);
	    } catch (e) {
	        dateValue = $(element).getDateValue();
	    }
	    
	    var formatted = $(element).formatDateValue(dateValue);
	    return (formatted == value);
			
		
	});

	$.validator.addMethod("ValidateLimitToList", function(value, element) {
		return $(element).attr('FailedLimitToList') == "False";
	}, "Please select a value from the drop down list");
})(jQuery);


